import React from "react";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

export default function Warranty() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Products</p>
        <h1>Product care &amp; warranty</h1>
        <p>Care, defects, normal wear, and remedies for direct purchases.</p>
        <span>Effective {POLICY_UPDATED}</span>
      </header>
      <div className="policy-layout">
        <PolicyNav current="/warranty" />
        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="warranty-overview">
            <p className="policy-eyebrow">Before and after purchase</p>
            <h2 id="warranty-overview">Care first. Fair remedies when something is wrong.</h2>
            <p>
              Product-page descriptions and written promises form part of your
              purchase. Any additional voluntary written warranty will be stated
              clearly on the applicable product page or accompanying materials.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-scope">
            <div className="policy-section__heading"><span>01</span><h2 id="warranty-scope">Scope</h2></div>
            <p>
              This policy applies to products purchased directly from this site.
              Keep your order confirmation as proof of purchase. A product made
              by a third party may also include its own manufacturer warranty;
              those written terms identify the warrantor, coverage, and claim method.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-care">
            <div className="policy-section__heading"><span>02</span><h2 id="warranty-care">Care responsibilities</h2></div>
            <p>
              Follow product-page, label, and packaging instructions. Test cleaning
              products on a hidden area, keep goods away from conditions they are
              not designed for, and stop using an item if damage could make it unsafe.
              Improper cleaning, storage, alteration, overloading, or use outside the
              stated purpose may affect available remedies where permitted by law.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-defects">
            <div className="policy-section__heading"><span>03</span><h2 id="warranty-defects">Defect or normal wear?</h2></div>
            <p>
              A defect is a problem in materials, construction, or conformity that
              existed at delivery or is otherwise covered by law or an express
              written promise. Normal softening, fading, creasing, surface wear,
              accidental damage, misuse, or reasonable material variation is not
              automatically a defect.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-claim">
            <div className="policy-section__heading"><span>04</span><h2 id="warranty-claim">Make a claim</h2></div>
            <p>
              Email {siteConfig.contact.email} with the order number, product name,
              date the issue appeared, how the item was used and cared for, and clear
              photographs or video. Keep the item and packaging while we review it;
              do not attempt a repair that could obscure the cause.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-remedies">
            <div className="policy-section__heading"><span>05</span><h2 id="warranty-remedies">Assessment &amp; remedies</h2></div>
            <p>
              We may request inspection or return of the item. If a covered issue is
              confirmed, the available remedy may be repair, replacement, refund,
              or another remedy required by law, taking account of the product and
              the nature of the problem. We cover reasonable return costs for a
              confirmed defect.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="warranty-rights">
            <div className="policy-section__heading"><span>06</span><h2 id="warranty-rights">Statutory rights</h2></div>
            <p>
              This page does not create a universal fixed-duration written warranty
              and does not exclude implied warranties or consumer remedies that
              cannot lawfully be excluded. Rights vary by jurisdiction; product-
              specific written warranty terms control only to the extent allowed by law.
            </p>
          </section>

          <section className="policy-help"><div><p className="policy-eyebrow">Product issue</p><h2>Show us what happened.</h2></div><a href={`mailto:${siteConfig.contact.email}`}>Start a review <span aria-hidden="true">↗</span></a></section>
        </article>
      </div>
    </main>
  );
}
